(() => {
  const header = document.querySelector('[data-scp-header]');
  const menuToggle = header?.querySelector('[data-scp-menu-toggle]');
  const mobileMenu = header?.querySelector('[data-scp-mobile-menu]');
  menuToggle?.addEventListener('click', () => {
    const open = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!open));
    mobileMenu.hidden = open;
  });

  const countdown = document.querySelector('[data-scp-countdown]');
  if (countdown) {
    const duration = Math.max(1, Number(countdown.dataset.hours || 12)) * 60 * 60 * 1000;
    const storageKey = 'sleepeasePatchesOfferEnds';
    let endsAt = Number(sessionStorage.getItem(storageKey));
    if (!endsAt || endsAt <= Date.now()) {
      endsAt = Date.now() + duration;
      sessionStorage.setItem(storageKey, String(endsAt));
    }
    const updateCountdown = () => {
      const secondsLeft = Math.max(0, Math.floor((endsAt - Date.now()) / 1000));
      countdown.querySelector('[data-scp-hours]').textContent = String(Math.floor(secondsLeft / 3600)).padStart(2, '0');
      countdown.querySelector('[data-scp-minutes]').textContent = String(Math.floor((secondsLeft % 3600) / 60)).padStart(2, '0');
      countdown.querySelector('[data-scp-seconds]').textContent = String(secondsLeft % 60).padStart(2, '0');
    };
    updateCountdown();
    window.setInterval(updateCountdown, 1000);
  }

  const roots = document.querySelectorAll('[data-scp-product]');
  if (!roots.length) return;

  const formatMoney = (cents, currency) => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(cents) / 100);
  };

  roots.forEach((root) => {
    const form = root.querySelector('[data-scp-form]');
    const idInput = root.querySelector('[data-scp-variant-id]');
    const submit = root.querySelector('[data-scp-submit]');
    const submitLabel = root.querySelector('[data-scp-submit-label]');
    const error = root.querySelector('[data-scp-error]');
    const mainImage = root.querySelector('[data-scp-main-image]');
    const configNode = root.querySelector('[data-scp-config]');
    const config = configNode ? JSON.parse(configNode.textContent) : { skipCart: false, buttonLabel: 'Add To Cart', root: '/' };

    const setImage = (url, alt) => {
      if (!mainImage || !url) return;
      mainImage.classList.add('is-changing');
      const preload = new Image();
      preload.onload = () => {
        mainImage.src = url;
        mainImage.srcset = '';
        mainImage.alt = alt || mainImage.alt;
        mainImage.classList.remove('is-changing');
      };
      preload.onerror = () => mainImage.classList.remove('is-changing');
      preload.src = url;
    };

    const selectVariant = (input, updateHistory = true) => {
      if (!input) return;
      idInput.value = input.value;
      root.querySelectorAll('[data-scp-option]').forEach((option) => option.classList.toggle('is-selected', option.contains(input)));
      root.querySelectorAll('[data-scp-thumb]').forEach((thumb) => {
        const active = thumb.dataset.variantId === input.value;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
      setImage(input.dataset.imageUrl, input.dataset.title);
      const available = input.dataset.available === 'true';
      submit.disabled = !available;
      submitLabel.textContent = available ? config.buttonLabel : 'Sold Out';
      if (updateHistory) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url);
      }
    };

    root.querySelectorAll('input[name="contact-patches-variant"]').forEach((input) => {
      input.addEventListener('change', () => selectVariant(input));
    });

    root.querySelectorAll('[data-scp-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const input = root.querySelector(`input[name="contact-patches-variant"][value="${CSS.escape(thumb.dataset.variantId)}"]`);
        if (input && !input.disabled) {
          input.checked = true;
          selectVariant(input);
        } else {
          setImage(thumb.dataset.imageUrl, thumb.getAttribute('aria-label'));
        }
      });
    });

    form?.addEventListener('submit', async (event) => {
      if (!config.skipCart) return;
      event.preventDefault();
      if (!idInput.value || submit.disabled) return;
      error.hidden = true;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submitLabel.textContent = 'Adding…';
      try {
        const response = await fetch(`${config.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(idInput.value), quantity: 1 })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'This selection could not be added.');
        window.location.assign(`${config.root}checkout`);
      } catch (issue) {
        error.textContent = issue.message || 'Something went wrong. Please try again.';
        error.hidden = false;
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
        submitLabel.textContent = config.buttonLabel;
      }
    });

    const selected = root.querySelector('input[name="contact-patches-variant"]:checked');
    if (selected) selectVariant(selected, false);
  });
})();
